// @flow
import React from 'react'

const Http404 = (): any => <div className='login'>
  <div className='login__header'>
    <i className='icon icon--logo' />
    <h3>Something Went Wrong</h3>
  </div>
  <h4>There was an issue logging you in. Please contact <a href='mailto:support@lanetix.com'>support@lanetix.com</a></h4>
</div>

export default Http404
